// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"1acc8506","513":"36db12ee","787":"8823a914"}[chunkId] + ".chunk.js";
};